import React from "react";
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from "../Frontend/Header";
import Hero from "../Frontend/Hero";
import Features from "../Frontend/Features";
import About from "../Frontend/About";
import HowItWorks from "../Frontend/HowItWorks";
import Pricing from "../Frontend/Pricing";
import Stats from "../Frontend/Stats";
import Contact from "../Frontend/Contact";
import Footer from "../Frontend/Footer";
import FAQ from "../Frontend/FAQ";
import Testimonial from "../Frontend/Testimonial";


const LandingPage = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleSignup = () => {
    navigate('/register');
  };

  return (
    <>
      <Header />
      <Hero />
	   <About />
      <Features />
      <HowItWorks />
	    <Pricing />
      <Stats />
	  <Testimonial />
	  <FAQ />
      {/*<section id="auth-section" className="section" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
        <Container>
          <Row>
            <Col md={8} className="mx-auto text-center">
              <h2 className="mb-4">Ready to Get Started?</h2>
              <p className="mb-5 fs-5">Join thousands of users who are already managing their finances with HamaraBill.</p>
              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <Button 
                  variant="light" 
                  size="lg" 
                  onClick={handleLogin}
                  className="px-5 py-3"
                >
                  Login to Your Account
                </Button>
                <Button 
                  variant="outline-light" 
                  size="lg" 
                  onClick={handleSignup}
                  className="px-5 py-3"
                >
                  Create Free Account
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>*/}
      <Contact />
      <Footer />
    </>
  );
};

export default LandingPage;
